import Web3 from "web3";
import { ethers } from 'ethers';

/*import Web3Modal from "web3modal";
import WalletConnectProvider from "@walletconnect/web3-provider";
import Fortmatic from "fortmatic";
import Authereum from "authereum";
import BurnerConnectProvider from "@burner-wallet/burner-connect-provider";
*/
import Onboard from '@gnosis.pm/safe-apps-onboard'
//import TransportWebUSB from "@ledgerhq/hw-transport-webusb";
import TransportU2F from "@ledgerhq/hw-transport-u2f";

import Notify from "bnc-notify"

import config from '@/constants/config'
import { getNowTimestamp } from '@/utils/Date'
import * as common from './utils/common.js'
import * as state from './contract.js'
import { infura_url, multicall_address, multicall_abi } from '@/constants/abis'

/*const providerOptions = {
    walletconnect: {
        package: WalletConnectProvider, // required
        options: {
          infuraId: "c334bb4b45a444979057f0fb8a0c9d1b" // required
        }
    },
    authereum: {
        package: Authereum, // required
        options: {}
    },
    burnerconnect: {
        package: BurnerConnectProvider, // required
        options: {}
    },
    fortmatic: {
        package: Fortmatic, // required
        options: {
          key: "pk_live_190B10CE18F47DCD" // required
        }
    }
};*/

/*const web3Modal = new Web3Modal({
  network: "mainnet", // optional
  cacheProvider: true, // optional
  providerOptions // required
});*/

export const notify = Notify({
  dappId: 'c68d8ec3-9b9a-4ba5-a3eb-6232eff79030',
  //9777c03e-be2e-4f99-84f9-5463fca4005d
  networkId: config.networkId,
  desktopPosition: 'topRight',
})

export function notifyHandler(hash) {
  let { emitter } = notify.hash(hash)
  emitter.on('all', transaction => ({
      onclick: () => window.open(`${config.explorerBaseUrl.tx}${transaction.hash}`, '_blank', 'noopener, norefferer')
    })
  )
}

export function notifyNotification(message, type = 'pending') {
  let notificationObject = {
    eventCode: 'notification',
    type: type,
    message: message,
  }

  return notify.notification(notificationObject)
}

let wallets = [
  { walletName: "metamask" },
  {
    walletName: "trezor",
    appUrl: "https://curve.fi",
    email: "info@curve.fi",
    rpcUrl:
      config.rpcUrl
  },
  {
    walletName: "ledger",
    rpcUrl:
      config.rpcUrl,
    LedgerTransport: TransportU2F,
  },
  { walletName: "dapper" },
  { walletName: "coinbase" },
  { walletName: "status" },
  { walletName: "fortmatic", apiKey: "pk_live_190B10CE18F47DCD" },
  { walletName: "authereum", apiKey: "_BTsipRcEmPeuVteLOGdoh1CXt733YLZ7u3ipbe_dAk" },
  {
    walletName: "trust",
    rpcUrl: config.rpcUrl,
  },
  {
    walletName: "walletConnect",
    infuraKey: "c334bb4b45a444979057f0fb8a0c9d1b"
  },
  {
    walletName: "walletLink",
    appName: 'Curve Finance',
    appLogoUrl: 'https://www.curve.fi/logo.png',
    rpcUrl:
      config.rpcUrl,
  },
  {
    walletName: "portis",
    apiKey: "a3bb2525-5101-4a9c-b300-febc6319c3b4"
  },
  { walletName: "torus" },
  { walletName: "squarelink", apiKey: "db2074f87c34f247593c" },
  { walletName: "opera" },
  { walletName: "operaTouch" },
  { walletName: "unilogin" },
  { walletName: "imToken", rpcUrl: config.rpcUrl },
  { walletName: "meetone" },
  { walletName: "mykey", rpcUrl: config.rpcUrl },
  { walletName: "huobiwallet", rpcUrl: config.rpcUrl },
  { walletName: "hyperpay" },
  { walletName: 'wallet.io', rpcUrl: config.rpcUrl },
  { walletName: 'lattice', appName: 'Curve Finance', rpcUrl: config.rpcUrl },
  { walletName: 'tokenpocket' },
  { walletName: 'dcent' },

]

let isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

export const onboard = config.blockchainId === 'ethereum' ?
    Onboard({
        dappId: 'c68d8ec3-9b9a-4ba5-a3eb-6232eff79030',       // [String] The API key created by step one above
        networkId: config.networkId,  // [Integer] The Ethereum network ID your Dapp uses.
        subscriptions: {
            wallet: async (wallet) => {
                state.contract.web3 = window.web3 = new Web3(wallet.provider)
                state.contract.theProvider = new Web3(wallet.provider)
                state.contract.walletName = wallet.name;
                state.contract.walletProvider = wallet.provider;
                state.contract.ethers = new ethers.providers.Web3Provider(wallet.provider);
                localStorage.setItem('selectedWallet', wallet.name)
            },
            network: (network) => {
                if(network !== config.networkId) {
                    state.contract.error = 'Error: wrong network type. Please switch to mainnet';
                    state.contract.showShares = false
                }
                else {
                    state.contract.error = ''
                    state.contract.showShares = true;
                }
            },
            address: (account) => {
                if(account === undefined) {
                    if(localStorage.getItem('-walletlink:https://www.walletlink.org:session:id') === null)
                        changeWallets()
                }
                else {
                    if(state.contract.default_account && state.contract.initializedContracts)
                        common.update_fee_info()
                    state.contract.default_account = account;
                }
            },
        },
        walletSelect: {
            wallets: wallets,
        },
        walletCheck: [
            { checkName: 'derivationPath' },
            { checkName: 'connect' },
            { checkName: 'accounts' },
            { checkName: 'network' },
        ],
    }) :
    null;

async function init(init = true, name, walletlink = false) {
    console.time('initswap')
    let default_account;
    state.contract.initializedContracts = false;

    try {
        if (config.blockchainId === 'ethereum') {
            let userSelectedWallet = await onboard.walletSelect(localStorage.getItem('selectedWallet'));
            if(userSelectedWallet) {
                await onboard.walletCheck();
            } else {
                window.web3 = new Web3(infura_url)
            }
            state.contract.web3 = window.web3;
            state.contract.multicall = new state.contract.web3.eth.Contract(multicall_abi, multicall_address)
            default_account = (await state.contract.web3.eth.getAccounts())[0];
        } else {
            let selectedNetwork;
            let provider = new Web3.providers.HttpProvider(config.rpcUrl);
            window.web3 = new Web3(provider);
            let ethereum = window.ethereum;
            if (ethereum) {
                await ethereum.enable();
                provider = new ethers.providers.Web3Provider(ethereum);

                const signer = provider.getSigner();
                state.contract.signer = signer
                selectedNetwork = await provider.getNetwork();
            }

            state.contract.web3 = window.web3
            state.contract.provider = provider

            // Check if the right network is selected
            const chainId = selectedNetwork?.chainId;
            if (chainId && chainId !== config.networkId) {
                state.contract.error = `Error: wrong network type. Please switch to ${config.name} mainnet.`;
                state.contract.networkIdError = `Error: wrong network type. Please switch to ${config.name} mainnet.`;
            } else {
                state.contract.error = '';
                state.contract.networkIdError = false;
                state.contract.walletName = 'MetaMask';
                state.contract.multicall = new state.contract.web3.eth.Contract(multicall_abi, multicall_address)

                if (ethereum) {
                    default_account = (await ethereum.request({ method: 'eth_accounts' }))[0]
                } else {
                    default_account = '';
                }
            }

            // Check whether the network is functioning properly
            if (!state.contract.networkIdError) {
                try {
                    const lastBlockNumber = await provider.getBlockNumber();
                    const { timestamp: lastBlockTimestamp } = await provider.getBlock(lastBlockNumber);

                    // Block time is usually b/w 2 and 20s
                    const isLastBlockDelayed = (getNowTimestamp() - lastBlockTimestamp) > 120;
                    state.contract.networkDelayError = isLastBlockDelayed ?
                        `The ${config.name} network seems to be having issues at the moment, please check back again soon.` :
                        '';

                } catch (err) {}
            }
        }

        state.contract.default_account = default_account;
        if(init) await state.init(name);
        state.contract.initializedContracts = true;
        console.timeEnd('initswap')
    }
    catch(err) {
        console.error(err)
    }

}

export async function changeWallets() {
    state.contract.default_account = '';

    if (config.blockchainId === 'ethereum') {
        await onboard.walletReset();
    } else {
        init();
    }

    localStorage.removeItem('selectedWallet');
    state.contract.totalShare = 0;

    if (config.blockchainId === 'ethereum') {
        await onboard.walletSelect();
        await onboard.walletCheck();
    }
}

// Detect if wallet_addEthereumChain method is available on wallet provider
export async function canAutomaticallyChangeNetwork() {
    const ERROR_CODE_METHOD_DOESNT_EXIST = -32601;

    try {
        await window.ethereum.request({
            method: 'wallet_addEthereumChain',
            params: [],
        });
    } catch (err) {
        if (err.code === ERROR_CODE_METHOD_DOESNT_EXIST) return false;
    }

    return true;
}

export async function changeNetwork() {
    const returnValue = await window.ethereum.request({
        method: 'wallet_addEthereumChain',
        params: [{
            chainId: `0x${config.networkId.toString(16)}`,
            chainName: config.name,
            nativeCurrency: {
                name: config.nativeCurrency.symbol,
                symbol: config.nativeCurrency.symbol,
                decimals: config.nativeCurrency.decimals,
            },
            rpcUrls: [config.publicRpcUrl || config.rpcUrl],
            blockExplorerUrls: [config.explorerBaseUrl.root],
        }],
    });

    const isSuccess = returnValue === null;
    if (isSuccess) window.location.reload();
}

export default init;
